export default {
  "t-engagement-management": "Gestion de l'Activité",
  "t-engagement-overview": "Aperçu de l'Engagement",
  "t-overview": "Aperçu",
  "t-device-model": "Modèle d'Appareil",
  "t-sn-range": "Plage SN",
  "t-start-number": "N° début",
  "t-end-number": "N° fin",
  "t-complete-sn-range-required": "Veuillez saisir la plage complète de recherche SN",
  "t-filter": "Filtrer",
  "t-activation-rate": "Taux d'Activation",
  "t-online-rate": "Taux en Ligne",
  "t-usage-rate": "Taux d'Utilisation",
  "t-high-frequency-activity-rate": "Taux d'Activité Élevée",
  "t-silent-devices": "Appareils Silencieux",
  "t-activated-devices-count": "{count} activés",
  "t-devices-count": "{count} appareils",
  "t-device-unit": "appareils",
  "t-compared-with-last-week": "vs semaine dernière",
  "t-trend": "Tendance",
  "t-trend-analysis": "Analyse des Tendances",
  "t-recent-7-days": "7 derniers jours",
  "t-recent-30-days": "30 derniers jours",
  "t-recent-7-days-metrics-trend": "Tendance des métriques des 7 derniers jours",
  "t-recent-30-days-metrics-trend": "Tendance des métriques des 30 derniers jours",
  "t-total-uptime": "Temps de Fonctionnement Total",
  "t-total-uptime-list": "Liste du Temps de Fonctionnement Total des Appareils",
  "t-total-uptime-list-desc": "Statistiques de la durée totale de connexion à TMS et de l'activité multi-signal pour chaque appareil",
  "t-heartbeat-statistics": "Statistiques de Battement de Coeur",
  "t-heartbeat": "Statistiques de Battement de Coeur",
  "t-heartbeat-statistics-list": "Liste des Statistiques des Signaux Actifs des Appareils",
  "t-heartbeat-statistics-list-desc": "Détails d'activité multi-signal par appareil (lecture de carte ou trafic ; tout seuil atteint compte comme actif)",
  "t-heartbeat-signal": "Signal Actif",
  "t-card-swipe-count": "Lectures de Carte",
  "t-print-count": "Impressions",
  "t-print-distance": "Distance d'impression",
  "t-business-traffic": "Trafic Métier",
  "t-screen-on-duration": "Durée Écran Allumé",
  "t-active-time": "Heure d'Activation",
  "t-active-time-list": "Liste des Heures d'Activation des Appareils",
  "t-active-time-list-desc": "Enregistre le moment où chaque appareil a terminé son activation et s'est connecté pour la première fois",
  "t-days-from-now": "Depuis",
  "t-days-ago": "il y a {count} jours",
  "t-inactive-device-alert": "Alerte Appareil Silencieux",
  "t-inactive-device-alert-list": "Liste des Alertes d'Appareils Silencieux",
  "t-inactive-device-alert-list-desc": "Appareils silencieux qui avaient des signaux actifs le mois dernier, mais aucun signal actif ce mois-ci et une durée en ligne insuffisante",
  "t-idle-device-alert": "Alerte Appareil Inactif en Ligne",
  "t-idle-device-alert-list": "Liste des Alertes d'Appareils Inactifs en Ligne",
  "t-idle-device-alert-list-desc": "Liste des alertes pour les appareils en ligne mais sans aucun signal actif pendant la période statistique (OR multi-signal L2 : lecture de carte/impression/trafic/écran allumé)",
  "t-idle-devices-total": "Total des Appareils Inactifs en Ligne",
  "t-idle-days": "Jours Inactifs en Ligne",
  "t-pending-activation": "Activation en Attente",
  "t-pending-activation-list": "Liste des Activations en Attente",
  "t-pending-activation-list-desc": "Appareils saisis dans le système TMS mais jamais activés en ligne, triés par nombre de jours depuis la saisie (les plus anciens nécessitent plus d'attention)",
  "t-pending-activation-total": "Total des Appareils en Attente d'Activation",
  "t-threshold-settings": "Paramètres de Seuil",
  "t-edit-threshold-settings": "Modifier les Paramètres de Seuil",
  "t-threshold-settings-list": "Liste des Paramètres de Seuil",
  "t-threshold-settings-list-desc": "Gérer les paramètres de seuil permettant de déterminer les niveaux d'activité dans le système",
  "t-threshold-config-name": "Nom de Configuration",
  "t-threshold-type": "Type de Seuil",
  "t-threshold-value": "Seuil",
  "t-threshold-type-online-duration": "Durée en Ligne",
  "t-threshold-type-silent-days": "Jours Silencieux",
  "t-threshold-type-idle-detection": "Détection d'Inactivité",
  "t-threshold-type-card-swipe-count": "Nombre de Lectures de Carte",
  "t-threshold-type-unactivated-days": "Jours Non Activés",
  "t-threshold-type-screen-on-duration": "Durée Écran Allumé",
  "t-threshold-type-business-traffic": "Trafic Métier",
  "t-online-duration-threshold": "Seuil de Durée en Ligne",
  "t-silent-device-threshold": "Seuil d'Appareil Silencieux",
  "t-idle-device-threshold": "Seuil d'Appareil Inactif",
  "t-high-frequency-active-threshold": "Seuil de Forte Activité",
  "t-unactivated-reminder-threshold": "Seuil de Rappel Non Activé",
  "t-screen-on-duration-threshold": "Seuil de Durée Écran Allumé",
  "t-business-traffic-threshold": "Seuil de Trafic Métier",
  "t-threshold-value-24h": "24 h",
  "t-threshold-value-7-days": "7 jours",
  "t-threshold-value-3-days": "3 jours",
  "t-threshold-value-50-times-day": "50 fois/jour",
  "t-threshold-value-30-days": "30 jours",
  "t-threshold-value-2h": "2 h",
  "t-threshold-value-10mb-day": "10 Mo/jour",
  "t-online-duration-threshold-desc": "Les appareils sont considérés actifs lorsque la durée en ligne continue dépasse ce seuil",
  "t-silent-device-threshold-desc": "Les appareils sont considérés silencieux si aucun signal actif n'est détecté après ce nombre de jours",
  "t-idle-device-threshold-desc": "Les appareils sont considérés inactifs lorsqu'ils restent en ligne sans activité métier au-delà de ce nombre de jours",
  "t-high-frequency-active-threshold-desc": "Les appareils sont considérés très actifs lorsque les lectures de carte quotidiennes dépassent ce seuil",
  "t-unactivated-reminder-threshold-desc": "Un rappel est déclenché lorsque les appareils restent non activés après ce nombre de jours depuis la saisie",
  "t-screen-on-duration-threshold-desc": "Les appareils sont comptés comme actifs lorsque la durée quotidienne d'écran allumé dépasse ce seuil",
  "t-business-traffic-threshold-desc": "Les appareils sont comptés comme actifs lorsque le trafic métier quotidien dépasse ce seuil",
  "t-pending-days": "Jours depuis la Saisie",
  "t-activation-analytics": "Analyse d'Activation",
  "t-activation-analytics-list": "Analyse d'Activation des Partenaires",
  "t-activation-analytics-list-desc": "Aperçu de l'état d'activation des appareils de chaque partenaire, avec tri par taux d'activation",
  "t-activation-analytics-total": "Total de l'Analyse d'Activation",
  "t-activation-rate-rank": "Taux d'Activation",
  "t-partner-count": "Partenaires",
  "t-average-activation-rate": "Taux d'Activation Moyen",
  "t-highest-activation-rate": "Taux d'Activation Maximal",
  "t-lowest-activation-rate": "Taux d'Activation Minimal",
  "t-network-devices": "Appareils en Ligne",
  "t-activated": "Activés",
  "t-unactivated": "Non Activés",
  "t-entry-time": "Heure de Saisie",
  "t-inventory-estimation": "Estimation du Stock",
  "t-latest-heartbeat": "Dernier Heartbeat",
  "t-suspected-in-inventory": "Suspecté en Stock",
  "t-long-term-not-powered-on": "Non allumé depuis longtemps",
  "t-contact-partner-for-verification": "Contacter le partenaire pour vérification",
  "t-idle-duration": "Durée Inactive",
  "t-hour-unit": "h",
  "t-idle-over-72-hours": "Inactif ≥72 Heures",
  "t-idle-24-72-hours": "Inactif 24-72 Heures",
  "t-idle-under-24-hours": "Inactif <24 Heures",
  "t-continuously-online-no-business": "En ligne en continu sans activité",
  "t-follow-up-business-opening-status": "Suivre le statut d'ouverture de l'activité",
  "t-possible-temporary-maintenance": "Possiblement maintenance temporaire",
  "t-current-online-status": "Statut en Ligne Actuel",
  "t-warning-level": "Niveau d'Alerte",
  "t-warning-high": "Élevé",
  "t-warning-medium": "Moyen",
  "t-warning-low": "Faible",
  "t-contact-merchant": "Contacter Marchand",
  "t-observe": "Observer",
  "t-last-month-active-signal": "Signal Actif du Mois Dernier",
  "t-this-month-active-signal": "Signal Actif de Ce Mois",
  "t-this-month-online-duration": "Durée en Ligne de Ce Mois",
  "t-total-online": "Total en Ligne",
  "t-last-active": "Dernière Heure en Ligne",
  "t-total-devices-count": "Total {count} appareils",
  "t-silent-devices-total": "Total des Appareils Silencieux",
  "t-risk-critical-days": "Critique (≥30 jours)",
  "t-risk-medium-days": "Moyen (14-29 jours)",
  "t-risk-watch-days": "Surveillance (7-13 jours)",
  "t-suspected-fault-or-permanent-offline": "Panne suspectée ou hors ligne permanent",
  "t-merchant-status-follow-up-needed": "Suivi du statut marchand requis",
  "t-continuous-monitoring": "Surveillance continue",
  "t-silent-days": "Jours Silencieux",
  "t-day-unit": "jours",
  "t-last-card-swipe-time": "Dernière Lecture de Carte",
  "t-risk-level": "Niveau de Risque",
  "t-risk-critical": "Critique",
  "t-risk-medium": "Moyen",
  "t-risk-watch": "Surveillance",
  "t-follow-up": "Suivre",
  "t-view-threshold-settings": "Voir les Paramètres de Seuil",
  "t-close": "Fermer",
  "t-fetch-failed": "Échec de la récupération des données",
  "t-save-success": "Enregistré avec succès",
  "t-save-failed": "Échec de l'enregistrement",
  "t-threshold-value-range": "La valeur du seuil doit être comprise entre 1 et 100",
}
